<template>
  <div class="wrap">
    <userList :customer="id" />
    <div style="grid-row-start: span 2">
      <el-empty title="暂无数据" />
    </div>
    <manList :customer="id" />
  </div>
</template>

<script>
export default {
  components: {
    userList: () => import('./_user.vue'),
    manList: () => import('./_man.vue')
  },
  data () {
    return {
      id: this.$route.params?.id
    }
  }
}
</script>


<style lang="scss" scoped>
.wrap {
  height: 100%;
  display: grid;
  grid-template-columns: 400px 1fr;
  grid-template-rows: repeat(2, auto);
  grid-gap: 16px;
}
</style>
